<template>
    <v-select
        v-model="department"
        :items="sortedDepartments"
        :label="props.label || $t('department')"
        item-value="id"
        item-title="name"
        clearable
    />
</template>

<script setup lang="ts">
    const props = defineProps<{
        label?: string
    }>()
    const department = defineModel<number>()
    const {departments} = useDepartments()
    const sortedDepartments = computed(() => departments.value.toSorted((a, b) => a.name.localeCompare(b.name)))
</script>
